<template>
  <pt-group-form class="pt-group-form__page" :is-edit="is_edit" :id="id"></pt-group-form>
</template>

<script>
import PtGroupForm from 'cps/mall-manage/pt-goods-group/pt-group-form'
export default {
  name: 'pt-group-form__view',
  props: {
    isEdit: {
      type: [Boolean, String],
      default: false
    },
    id: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      is_edit: this.isEdit === 'true'
    }
  },
  components: {
    'pt-group-form': PtGroupForm
  },
  created () {
  }
}
</script>
